module.exports = __webpack_public_path__ + "img/story021@2x.f2a8905e.webp";